import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSelfHeal } from "./lib/selfHeal";
import { initPoolDebug } from "./lib/poolDebug";

// ── Dev-only: suppress spurious forwardRef warnings ──────────────────────────
// The lovable-tagger `componentTagger()` Vite plugin injects a ref callback
// into every JSX element for source-location tracking. React 18.3 fires a
// "Function components cannot be given refs" warning for each one, flooding
// the console with noise unrelated to our code. This filter silences only
// that specific message in development; production builds never run the
// tagger so no warning is emitted there.
if (import.meta.env.DEV) {
  const origError = console.error;
  console.error = (...args: unknown[]) => {
    if (
      typeof args[0] === "string" &&
      args[0].includes("Function components cannot be given refs")
    ) {
      return; // suppress tagger-injected ref warnings
    }
    origError.apply(console, args);
  };
}

// Boot self-healing before React renders
initSelfHeal();
initPoolDebug();

createRoot(document.getElementById("root")!).render(<App />);
